import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { baseUrl } from "../../Components/baseUrl";
import { toast } from "react-toastify";
import "bootstrap/dist/css/bootstrap.css";
import Menu from "../../Components/Menu";

const Canceled = () => {
    const navigate = useNavigate();
    let token;
    if (typeof window !== "undefined") {
        token = localStorage.getItem("token");
    }
    useEffect(() => {
        document.title = "پایا | کنسل شده";
        token == null && navigate("/login", { replace: true });
    }, []);
    const [loading, setLoading] = useState(true);
    const [list, setList] = useState([]);
    useEffect(() => {
        let status = {
            status: [7],
        };
        let config = {
            url: `${baseUrl}/orders/get-orders-by-status`,
            method: "POST",
            data: status,
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setList(res.data.data);
                setLoading(false);
            })
            .catch((err) => {
                setLoading(false);
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    }, []);
    const [searchText, setSearchText] = useState("");
    const searchOrder = (e) => {
        let config = {
            url: `${baseUrl}/orders?search=${searchText}&status=1`,
            method: "GET",
        };
        axios(config)
            .then((res) => {
                res && res.data && res.data.data && setList(res.data.data);
            })
            .catch((err) => {
                toast.error(err.response.data.message, {
                    position: "top-center",
                    autoClose: 5000,
                    hideProgressBar: false,
                    closeOnClick: true,
                    pauseOnHover: true,
                    draggable: true,
                    progress: undefined,
                });
            });
    };
    return (
        <div className="container">
            <div className="search-box" id="search_box">
                <div className="pos-rel-search">
                    <input
                        value={searchText}
                        onChange={(e) => setSearchText(e.target.value)}
                        type="text"
                        placeholder="جستجو کنید"
                    />
                    <svg
                        onClick={() => searchOrder()}
                        className="search-svg"
                        width="24"
                        height="24"
                        viewBox="0 0 24 24"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            d="M18.5831 13.5489C19.204 11.7018 19.1293 9.69155 18.3731 7.89557C17.6169 6.09959 16.2312 4.64137 14.4761 3.79465C12.7209 2.94793 10.7171 2.77094 8.84074 3.29691C6.96438 3.82287 5.3445 5.01562 4.28521 6.65125C3.22592 8.28688 2.80005 10.2529 3.08754 12.1803C3.37504 14.1076 4.35614 15.8638 5.84666 17.1191C7.33718 18.3744 9.23463 19.0424 11.1828 18.9979C13.131 18.9534 14.9959 18.1993 16.4275 16.8772"
                            stroke="#A2A2A2"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                        <path
                            d="M16.5 16.958L21.5 21.958"
                            stroke="#A2A2A2"
                            strokeWidth="1.5"
                            strokeLinecap="round"
                            strokeLinejoin="round"
                        />
                    </svg>
                </div>
            </div>
            {loading ? (
                <div className="emp-main">
                    <img src="/assets/images/loading.gif" width={50} />
                </div>
            ) : list && list.length !== 0 ? (
                <div className="orders-main">
                    <h1>سفارشات کنسل شده</h1>
                    {list &&
                        list.length !== 0 &&
                        list.map((item) => {
                            if (item.Status == "کنسل شده") {
                                return (
                                    <a
                                        className="orders-card"
                                        onClick={(e) => {
                                            navigate(
                                                "/panel/factor/" + item.id
                                            );
                                        }}
                                    >
                                        <img
                                            src={
                                                item.company.avatar
                                                    ? item.company.avatar
                                                    : "/assets/images/logo.svg"
                                            }
                                            alt=""
                                        />
                                        <div>
                                            <span className="name">
                                                {item.company.store_name}
                                            </span>
                                            <span className="fullname">
                                                {item.company.name}{" "}
                                            </span>
                                            <span className="numb">
                                                {item.code}
                                            </span>
                                            <div className="dates">
                                                <button>{item.Status}</button>
                                                <span>{item.Created_at}</span>
                                            </div>
                                        </div>
                                    </a>
                                );
                            }
                        })}
                </div>
            ) : (
                <div className="emp-main">
                    <svg
                        width="145"
                        height="145"
                        viewBox="0 0 145 145"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                    >
                        <path
                            opacity="0.4"
                            d="M72.4999 132.917C105.867 132.917 132.917 105.867 132.917 72.5C132.917 39.1328 105.867 12.0833 72.4999 12.0833C39.1327 12.0833 12.0833 39.1328 12.0833 72.5C12.0833 105.867 39.1327 132.917 72.4999 132.917Z"
                            fill="#FF0000"
                        />
                        <path
                            d="M78.9042 72.5L92.8 58.6042C94.5521 56.8521 94.5521 53.9521 92.8 52.2C91.048 50.4479 88.148 50.4479 86.3959 52.2L72.5 66.0958L58.6042 52.2C56.8521 50.4479 53.9521 50.4479 52.2 52.2C50.448 53.9521 50.448 56.8521 52.2 58.6042L66.0959 72.5L52.2 86.3958C50.448 88.1479 50.448 91.0479 52.2 92.8C53.1063 93.7062 54.2542 94.1292 55.4021 94.1292C56.55 94.1292 57.698 93.7062 58.6042 92.8L72.5 78.9042L86.3959 92.8C87.3021 93.7062 88.4501 94.1292 89.598 94.1292C90.7459 94.1292 91.8938 93.7062 92.8 92.8C94.5521 91.0479 94.5521 88.1479 92.8 86.3958L78.9042 72.5Z"
                            fill="#FF0000"
                        />
                    </svg>

                    <p className="emp-text">هیچ سفارش کنسلی ثبت نشده است</p>
                </div>
            )}
            <Menu active="cart" />
        </div>
    );
};

export default Canceled;
